export default __webpack_public_path__ + "static/media/Nestle.2c2b41de.png";